export const initialHomeSmartModulesState = {
    smartModulesById: {},
    smartModuleIdsByHomeId: {},
};
